import {
  Grid,
  TextField,
  Typography
} from "@mui/material";
import React from "react";
import { Controller } from "react-hook-form";

interface RoleDetailsFormProps {
  control: any;
  handleSubmit: any;
  id_organizacion: string | null;
  isCreating: boolean;
}

const RoleDetailsForm: React.FC<RoleDetailsFormProps> = ({
  control,
  handleSubmit,
  id_organizacion,
  isCreating,
}) => {
  return (
    <Grid
      container
      sx={{
        p: 2,
        borderRadius: 2,
        border: "1px solid #ccc",
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Grid item>
        <Typography variant="h6" fontWeight="bold">
          Detalles del Rol
        </Typography>
      </Grid>

      <Grid container spacing={3} component="form" onSubmit={handleSubmit}>
        {/* Nombre */}
        <Grid item xs={12} md={6}>
          <Controller
            name="nombre"
            control={control}
            defaultValue=""
            disabled={isCreating}
            rules={{
              required: "El nombre es obligatorio",
              validate: (value) => {
                const trimmedValue = value.trim();
                const invalidNames = [
                  "Admin de Dominio",
                  "Profesor",
                  "Admin de Organización",
                ];
                if (invalidNames.includes(trimmedValue)) {
                  return "Este nombre no está permitido";
                }
                return true;
              },
            }}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                label="Nombre"
                fullWidth
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
              />
            )}
          />
        </Grid>

        {/* Descripción */}
        <Grid item xs={12} md={6}>
          <Controller
            name="descripcion"
            control={control}
            defaultValue=""
            disabled={isCreating}
            render={({ field }) => (
              <TextField
                {...field}
                label="Descripción"
                fullWidth
                multiline
                rows={3}
              />
            )}
          />
        </Grid>

        {/* ID Organización */}
        <Grid item xs={12} md={6}>
          <TextField
            name="id_organizacion"
            label="ID Organización"
            fullWidth
            value={id_organizacion}
            disabled
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default RoleDetailsForm;
